<!--
 * @Description: 主菜单 小屏
 * @Author: PF
 * @Date: 2024-08-20 16:40:48
 * @LastEditors: PF
 * @LastEditTime: 2026-08-26 10:26:40
-->
<template>
  <div v-show="isDrawer" :class="isDrawer ? 'system_menu' : 'menu_retract'" v-click-outside="drawerClose">
    <el-container class="hp100">
      <el-header>
        <div class="top">
          <el-icon class="mr10"><Menu /></el-icon>
          <span>数字化校园</span>
        </div>
        <el-divider />
      </el-header>
      <el-main>
      <el-scrollbar height="100%">
        <ul class="menu_list">
          <li v-for="(item, index) in menuList" :key="index" :index="item.id" @click="handleClickspan(item)">
            <span v-if="item.tb" :class="'iconfont icon-' + item.tb" style="font-size: 20px;margin-right: 5px;"></span>
            <span>{{ item.cdmc }}</span>
          </li>
        </ul>
      </el-scrollbar>
    </el-main>
  </el-container>
  </div>
</template>

<script setup>
import { ref, defineEmits, defineProps, watch } from 'vue'
import { useRouter } from 'vue-router'
import { ClickOutside as vClickOutside } from 'element-plus'

const props = defineProps({ isDrawer: { type: Boolean, required: true }, row: { type: Object, required: false } })

// ───────────────────────────── 路由 ─────────────────────────────
const router = useRouter()
// 内部路由用 router.push（不刷新），未注册路由降级为新窗口打开
const safePush = (url) => {
  if (router.resolve(url).matched.length) router.push(url)
  else window.open(url, '_parent')
}

// 关闭菜单
const emits = defineEmits(['update:isDrawer'])
const drawerClose = () => {
  emits('update:isDrawer', false)
}

const userInfo = ref({})
const menuList = ref([])

// 菜单点击
const handleClickspan = (item) => {
  drawerClose()
  if (!item.zjlj) {
    window.open(item.cdlj, '_blank')
    window.open('/', '_self')
  } else {
    safePush(item.cdlj)
  }
}

// 菜单列表
const initMenuList = async (list) => {
  list.forEach((element, index) => {
    if (element.sfyc) {
      list.splice(index, 1)
    }
  })
  menuList.value = list
}

watch(
  () => props.row,
  () => {
    if (props.row) {
      userInfo.value = props.row.userInfo
      initMenuList(props.row.list)
    }
  },
  { deep: true, immediate: true }
)

</script>

<style lang="less" scoped>
.system_menu {
  width: 300px;
  position: fixed;
  top: 60px;
  bottom: 44px;
  left: 0px;
  border-radius: 10px;
  background-color: rgb(10 10 10 / 50%);
  backdrop-filter: blur(23px);
  margin: 0 auto;
  border-radius: 15px;
  border: 1px solid #ffffff12;
  color: #fff;
  padding: 24px 20px;
  animation-duration: 1s;
  z-index: 99;

  .el-input {
    padding: 10px;
  }
  .top {
    color: #fff;
    font-size: 24px;
    display: flex;
    align-items: center;
    i {
      color: #fff;
    }
  }
  .select_main_tone {
    float: right;
    margin: 5px;
    width: 30px;
    height: 30px;
    background-color: #0000004d;
    color: #fff;
    border-radius: 50%;
  }

  .menu_list {
    height: calc(100% - 60px);
    width: 100%;
    overflow: auto;
    color: #fff;
    font-size: 18px;
    li {
      padding: 5px 10px;
      margin: 5px 0;
      cursor: pointer;
    }
    li:hover {
      color: #409eff;
    }
    li:nth-child(1) {
      margin-top: 0px;
      padding-top: 0px;
    }
  }
}

.menu_retract {
  display: none;
}

</style>
